"use client";

import { FC } from "react";
import AnnouncementBanner from "apps/website/components/page/AnnouncementBanner/AnnouncementBanner";
import type { IconSvg } from "apps/website/components/base/Icon/Icon.map";

export interface ILandingPageClientBannerProps {
  announcementText?: string;
  icon?: IconSvg;
  linkTo?: string;
}

const LandingPageClientBanner:FC<ILandingPageClientBannerProps> = ({ announcementText = "GET 20% OFF YOUR 14-DAY TRIAL", icon, linkTo = "/forms/fresh-food-new-user?discount_code=TRY20" }) => (
  <>
    { /* Desktop banner */ }
    <AnnouncementBanner
      announcements={[ {
        text: announcementText,
        to: linkTo,
        icon,
      } ]}
      theme="pink"
      className="hidden xl:flex"
      positionClassName="top-0 z-[45]"
      hideSpacerDiv={ true }
    />
    { /* Mobile banner */ }
    <AnnouncementBanner
      announcements={[ {
        text: announcementText,
        to: linkTo,
        icon,
      } ]}
      theme="pink"
      className="flex xl:hidden"
      positionClassName="top-[50px] z-[45]"
      hideSpacerDiv={true}
    />
  </>
);

export default LandingPageClientBanner;
